var staticEncodeURIComponent = encodeURIComponent

module.exports = staticEncodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticEncodeURIComponent.js
// module id = 534
// module chunks = 75